import { render, staticRenderFns } from "./study-participants-edc-data-dashboard.vue?vue&type=template&id=4e0890de&scoped=true&"
import script from "./study-participants-edc-data-dashboard.vue?vue&type=script&lang=js&"
export * from "./study-participants-edc-data-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./study-participants-edc-data-dashboard.vue?vue&type=style&index=0&id=4e0890de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0890de",
  null
  
)

component.options.__file = "study-participants-edc-data-dashboard.vue"
export default component.exports